import * as React from 'react';

function SvgComponent(props) {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 50 50" {...props}>
      <defs>
        <clipPath id="prefix__a">
          <path d="M0 0h50v50H0z" />
        </clipPath>
      </defs>
      <g clipPath="url(#prefix__a)">
        <rect
          data-name="Rectangle 734"
          width={48}
          height={47.5}
          rx={2}
          fill={props.fillPrimary}
          transform="translate(1 1)"
        />
        <g data-name="Group 2653">
          <path
            data-name="Path 5674"
            d="M15.929 6.55c.447.039 1.014.076 1.576.144a.463.463 0 00.531-.268c.285-.506.593-1 .9-1.49a1.251 1.251 0 011.679-.545c.552.219 1.092.47 1.652.668a.616.616 0 00.5-.081c.46-.354.885-.753 1.331-1.125a1.248 1.248 0 011.8-.006c.436.362.873.726 1.288 1.113a.493.493 0 00.627.094c.5-.232 1.015-.439 1.527-.647a1.268 1.268 0 011.742.56c.294.468.6.932.859 1.419a.53.53 0 00.633.3 21.47 21.47 0 011.737-.141 1.211 1.211 0 011.327 1c.142.548.29 1.1.392 1.654a.536.536 0 00.487.5c.569.112 1.133.254 1.693.4a1.221 1.221 0 01.987 1.342 20.287 20.287 0 01-.146 1.653.616.616 0 00.359.73c.488.258.953.56 1.42.858a1.236 1.236 0 01.533 1.614q-.331.85-.7 1.683a.407.407 0 00.079.514c.374.408.727.835 1.087 1.255a1.289 1.289 0 01.019 1.924c-.339.4-.664.818-1.034 1.19a.557.557 0 00-.1.729c.226.489.428.989.629 1.488a1.266 1.266 0 01-.553 1.713c-.48.3-.959.607-1.456.879a.491.491 0 00-.284.565c.062.522.1 1.046.144 1.57a1.3 1.3 0 01-1.11 1.574c-.549.139-1.107.248-1.648.411a.616.616 0 00-.361.355c-.17.583-.284 1.182-.436 1.771a1.263 1.263 0 01-1.421 1c-.579-.048-1.16-.085-1.737-.149a.472.472 0 00-.524.286c-.279.494-.581.975-.883 1.454a1.255 1.255 0 01-1.712.543 47.326 47.326 0 01-1.6-.676.409.409 0 00-.514.076c-.439.4-.895.785-1.353 1.164a1.243 1.243 0 01-1.762 0 31.865 31.865 0 01-1.321-1.137.459.459 0 00-.585-.083 32.66 32.66 0 01-1.6.673 1.251 1.251 0 01-1.675-.559c-.287-.456-.585-.908-.835-1.385a.6.6 0 00-.695-.352c-.508.062-1.021.085-1.53.136a1.281 1.281 0 01-1.524-1.066c-.142-.562-.253-1.133-.417-1.689a.619.619 0 00-.359-.359c-.569-.167-1.153-.284-1.73-.427a1.25 1.25 0 01-1.039-1.388c.031-.552.078-1.1.146-1.654a.6.6 0 00-.345-.7c-.477-.25-.929-.548-1.386-.833a1.264 1.264 0 01-.558-1.71c.217-.538.432-1.077.674-1.605a.432.432 0 00-.091-.547c-.383-.419-.746-.855-1.111-1.289a1.266 1.266 0 01.014-1.858c.367-.432.731-.868 1.113-1.287a.408.408 0 00.083-.514 38.782 38.782 0 01-.691-1.643 1.253 1.253 0 01.551-1.677c.469-.294.932-.6 1.421-.857a.565.565 0 00.327-.666c-.064-.507-.1-1.019-.142-1.529a1.3 1.3 0 011.133-1.562c.538-.129 1.075-.258 1.616-.369a.447.447 0 00.392-.4c.115-.554.253-1.1.391-1.654.188-.799.614-1.111 1.569-1.075z"
            fill={props.fillSecondary}
          />
          <path
            data-name="Path 5675"
            d="M8.67 31.767a3.819 3.819 0 002.8 2.071c.287.055.366.206.427.461a3.7 3.7 0 002.725 2.986 9.628 9.628 0 001.56.1c.165.014.4.078.469.2a3.994 3.994 0 002.727 2.049c-.108.124-.182.219-.266.3q-2.757 2.759-5.518 5.516a1.274 1.274 0 01-2.317-.54c-.5-1.492-1-2.984-1.488-4.481a.681.681 0 00-.49-.489c-1.51-.491-3.015-1-4.523-1.5a1.261 1.261 0 01-.547-2.248q2.078-2.088 4.167-4.167c.074-.076.156-.148.274-.258z"
            fill={props.fillSecondary}
          />
          <path
            data-name="Path 5676"
            d="M30.62 39.631a3.835 3.835 0 002.662-1.977.491.491 0 01.563-.281 3.706 3.706 0 004.243-3.02c.073-.308.18-.467.509-.531a3.84 3.84 0 002.783-2.15c.21.258.358.478.542.663 1.266 1.276 2.542 2.543 3.811 3.818a1.27 1.27 0 01-.533 2.3c-1.506.5-3.011 1.009-4.521 1.5a.646.646 0 00-.461.463c-.5 1.523-1 3.042-1.513 4.56a1.256 1.256 0 01-2.227.545q-2.808-2.8-5.606-5.6c-.077-.083-.144-.166-.252-.29z"
            fill={props.fillSecondary}
          />
        </g>
        <text
          transform="translate(25 32)"
          fill={props.fillPrimary}
          fontSize={32}
          fontFamily="Rubik-Bold, Rubik"
          fontWeight={700}
        >
          <tspan x={-11.52} y={0}>
            {'G'}
          </tspan>
        </text>
      </g>
    </svg>
  );
}

export default SvgComponent;
